import { useEffect, useState } from "react";

import {
  consentCookieName,
  CONSENT_CHANGED_EVENT,
  CookieConsent,
  getCookieConsent,
  hasConsentedToAnalytics,
} from "@/utils/cookies";

/**
 * React hook that returns whether the user has consented to analytics.
 * It updates in real-time when consent changes in this tab or other tabs.
 */
export function useHasConsentedToAnalytics(): boolean {
  const [hasConsented, setHasConsented] = useState<boolean>(() => {
    if (typeof window === "undefined") return false;
    return hasConsentedToAnalytics();
  });

  useEffect(() => {
    if (typeof window === "undefined") return;

    const handleCustomEvent = (event: Event) => {
      try {
        const detail = (event as CustomEvent<CookieConsent>).detail;
        if (detail && typeof detail.analytics === "boolean") {
          setHasConsented(!!detail.analytics);
          return;
        }
      } catch {}
      setHasConsented(hasConsentedToAnalytics());
    };

    const handleStorage = (e: StorageEvent) => {
      if (e.key && e.key !== consentCookieName()) return;
      // Re-read from storage, covers cross-tab changes
      const consent = getCookieConsent();
      setHasConsented(!!consent?.analytics);
    };

    window.addEventListener(CONSENT_CHANGED_EVENT, handleCustomEvent as EventListener);
    window.addEventListener("storage", handleStorage);

    return () => {
      window.removeEventListener(
        CONSENT_CHANGED_EVENT,
        handleCustomEvent as unknown as EventListener,
      );
      window.removeEventListener("storage", handleStorage);
    };
  }, []);

  return hasConsented;
}
































